import {ApplicationName, ApplicationAuthPaths} from './authContstants';
import {createUserManager, loadUser} from 'redux-oidc';
import {UserManager, WebStorageStateStore} from 'oidc-client';
import {AppStore} from 'app/store';

let _userManager: UserManager | null = null;

export const setupUserManager = async (store: AppStore) => {
    const userManager = await getUserManager();
    await loadUser(store, userManager);
    return userManager;
};

export const getUserManager = async () => {
    if (_userManager) return _userManager;
    
    const response = await fetch(ApplicationAuthPaths.ApiAuthorizationClientConfigurationUrl);
    if (!response.ok) {
        throw new Error(`Could not load settings for '${ApplicationName}'`);
    }

    const settings = await response.json();
    settings.automaticSilentRenew = true;
    settings.includeIdTokenInSilentRenew = true;
    settings.userStore = new WebStorageStateStore({
        prefix: ApplicationName
    });
    _userManager = createUserManager(settings);
    return _userManager;
};